import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  align?: "left" | "center" | "right";
  size?: "m" | "s";
}

export default /*#__PURE__*/_defineComponent({
  __name: 'form-unit-cell',
  props: {
    modifires: { type: [String, Array, Boolean] },
    align: {},
    size: {}
  },
  setup(__props: any) {

const props = __props;



const componentClass = () =>
  mapModifires(
    "form-unit-cell",
    mergeModifires(
      props.modifires,
      props.align && `align-${props.align}`,
      props.size && `size-${props.size}`
    )
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})